import { render, staticRenderFns } from "./LayoutTable.vue?vue&type=template&id=d983f18c&"
import script from "./LayoutTable.vue?vue&type=script&lang=js&"
export * from "./LayoutTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LayoutTable.vue"
export default component.exports